import React, { useEffect } from 'react'
import { LandingPageBottom } from './landing_page_bottom'
import { LandingPageTop } from './landing_page_top'
import { useRest } from '../../contexts/rest/use'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useConfig } from '../../contexts/config/use'
import { isFalsyOrEmpty } from '../helpers/object'
import { useHistory } from "react-router-dom"
import { CircularProgress } from '@material-ui/core'

export const LandingPage = () => {
  const { state: {offices, ticket, searchfilter}, actions: {toExistingTicket}} = useRest();
  const { actions: {t}} = useTranslation();
  const { state: { config, loadedpalette }, actions: { GetUrlIDFromOfficeID }} = useConfig();
  const theme = useTheme();
  const classes = useStyle(theme);
  const history = useHistory();

  useEffect(() => {
    if (!isFalsyOrEmpty(ticket) && !ticket.cancelled)
      toExistingTicket(ticket);
    if(!isFalsyOrEmpty(config) && !config.uselandingpage)
    {
      history.push("queues")

    }
  },[ticket])

  useEffect(() => {
    if(config)
    {
      var office = localStorage.getItem("selectedoffice");
      if(!isFalsyOrEmpty(ticket) && !ticket.cancelled)
        history.push('ticket')
      else if(office)
        history.push('queues?officeID=' + GetUrlIDFromOfficeID(office));
      else if (!config.uselandingpage)
        history.push('404')
    }
  }, [config])

  if ( loadedpalette && !isFalsyOrEmpty(config) && config.uselandingpage)
  {
    return (
        <div className={classes.container}>
          <LandingPageTop 
            organization={t('landingpage.organization')} 
            searchboxlabel={t('landingpage.searchbox.label')} 
            searchbuttontext={t('landingpage.searchbutton')} 
            findnearmetext={t('landingpage.nearmebutton')} 
            ortext={t('landingpage.ortext')}
            noresulttext={t('landingpage.searchbox.noresulttext')}
            />
          <LandingPageBottom offices={(!isFalsyOrEmpty(offices)) ? offices : null} filter={searchfilter || ""}/>
        </div>
      )
  }
  else
   return (
      <div className={classes.spinnercontainer} id="landing-spinnercontainer-id">
        <CircularProgress className={[classes.spinner, "Spinner"].join(' ')} id="landing-spinner-id" />
      </div>
    )
}

const useStyle = makeStyles({
  container: theme => ({
    backgroundColor: '#f4f4f4',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  }),
  spinnercontainer: {
    backgroundColor: '#f4f4f4',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: theme => ({
    color: theme.palette.primary.main
  }),
  backdrop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
})
